import React, { useEffect, useRef, useState } from "react";
import {
  Grid,
  Typography,
  FormControl,
  InputLabel,
  OutlinedInput,
  FormHelperText,
  Button,
  Box,
} from "@mui/material";
import AppContainer from "../../components/containers/AppContainer";
import NavigationDrawer from "../../components/navigationDrawer";
import RichTextEditorPage from "../../components/textEditor";
import CustomBar from "../../components/customBar";
import { getSettings, updateSettings } from "../../services/adminFn";
import CustomSnackbar from "../../components/customSnackBar/customSnackBar";
import AppLoader from "../../components/loader/loader";

const Setting = () => {
  const snackRef = useRef(null);
  const [settings, setSettings] = useState(null);
  console.log(settings, "settingssettingssettingssettings");

  const [isLoading, setIsLoading] = useState(false);

  useEffect(() => {
    fetchSettings();
  }, []);

  const fetchSettings = async () => {
    setIsLoading(true);
    try {
      const res = await getSettings();
      if (res.status === 200) {
        setSettings(res.data.data);
      } else {
        snackRef.current?.isOpenSnack("error", res.data.message);
      }
    } catch (err) {
      console.error(err);
      snackRef.current?.isOpenSnack("error", "Failed to load settings");
    } finally {
      setIsLoading(false);
    }
  };

  const handleChangeTax = (field, value) => {
    console.log(`Field: ${field}, Value:`, value);
    setSettings((prev) => ({ ...prev, [field]: value }));
  };

  const handleUpdateAll = async () => {
    if (!settings) return;
    setIsLoading(true);
    try {
      const payload = {
        privacyPolicy: settings.privacyPolicy,
        termsAndCondition: settings.termsAndCondition,
        termsOfJob: settings.termsOfJob,
        gst: settings.gst,
        qst: settings.qst,
      };
      const res = await updateSettings(settings._id, payload);
      const type = res.data.status === "success" ? "success" : "error";
      fetchSettings();
      snackRef.current?.isOpenSnack(type, res.data.message);
    } catch (err) {
      console.error(err);
      snackRef.current?.isOpenSnack("error", "Update failed");
    } finally {
      setIsLoading(false);
    }
  };

  if (isLoading || !settings) {
    return <AppLoader isVisible={true} />;
  }

  return (
    <NavigationDrawer>
      <CustomBar title="SETTINGS" />

      <AppContainer styleProps={{ padding: 4 }}>
        <Typography variant="h6" gutterBottom>
          TAX (in %)
        </Typography>
        <Grid container spacing={4}>
          <Grid item xs={12} md={6}>
            <FormControl fullWidth variant="outlined">
              <InputLabel htmlFor="gst-rate">GST Rate (%)</InputLabel>
              <OutlinedInput
                id="gst-rate"
                type="number"
                value={settings.gst}
                onChange={(e) =>
                  handleChangeTax("gst", parseFloat(e.target.value) || 0)
                }
                endAdornment={
                  <Box component="span" sx={{ mr: 1 }}>
                    %
                  </Box>
                }
                label="GST Rate (%)"
              />
              <FormHelperText>
                Enter your current GST percentage.
              </FormHelperText>
            </FormControl>
          </Grid>
          <Grid item xs={12} md={6}>
            <FormControl fullWidth variant="outlined">
              <InputLabel htmlFor="qst-rate">QST Rate (%)</InputLabel>
              <OutlinedInput
                id="qst-rate"
                type="number"
                value={settings.qst}
                onChange={(e) =>
                  handleChangeTax("qst", parseFloat(e.target.value) || 0)
                }
                endAdornment={
                  <Box component="span" sx={{ mr: 1 }}>
                    %
                  </Box>
                }
                label="QST Rate (%)"
              />
              <FormHelperText>
                Enter your current Quebec QST percentage.
              </FormHelperText>
            </FormControl>
          </Grid>
        </Grid>
      </AppContainer>

      <AppContainer styleProps={{ mt: 3 }}>
        <RichTextEditorPage
          title="Privacy Policy"
          dataKey="privacyPolicy"
          value={settings.privacyPolicy}
          onChange={(newVal) => handleChangeTax("privacyPolicy", newVal)}
        />
      </AppContainer>

      <AppContainer styleProps={{ mt: 3 }}>
        <RichTextEditorPage
          title="Terms and Conditions"
          value={settings.termsAndCondition}
          onChange={(newVal) => handleChangeTax("termsAndCondition", newVal)}
        />
      </AppContainer>

      <AppContainer styleProps={{ mt: 3 }}>
        <RichTextEditorPage
          title="Job Terms and Conditions"
          value={settings.termsOfJob}
          onChange={(newVal) => handleChangeTax("termsOfJob", newVal)}
        />
      </AppContainer>

      <AppContainer styleProps={{ mt: 4, textAlign: "center" }}>
        <Button
          variant="contained"
          fullWidth
          onClick={handleUpdateAll}
          disabled={isLoading}
          sx={{
            py: 1.5,
            fontSize: 16,
            fontWeight: "bold",
            borderRadius: 2,
            backgroundColor: "#630000",
            boxShadow: "0px 4px 12px rgba(0,0,0,0.15)",
            transition: "transform 0.2s",
            "&:hover": {
              transform: "scale(1.02)",
              boxShadow: "0px 6px 18px rgba(0,0,0,0.2)",
            },
          }}
        >
          {isLoading ? "Updating..." : "UPDATE SETTINGS"}
        </Button>
      </AppContainer>

      <CustomSnackbar ref={snackRef} />
      <AppLoader isVisible={isLoading} />
    </NavigationDrawer>
  );
};

export default Setting;
